import Head from 'next/head'

import { getMainWebLayout } from '@/components/layout/web'
import { getWebSignedInLayout } from '@/components/layout/web/WebSignedInLayout'
import { WebPageBanner } from '@/components/web-page-banner'
import { WebUserSettingsTab } from '@/components/web-user-settings-tab'
import { compose } from '@/utils/fun'

export default function UserSetting() {
  return (
    <>
      <Head>
        <title>ロジックラボ | 会員ページ</title>
      </Head>
      <section className="grow">
        <WebPageBanner title="ロジックラボ 会員ページ" />

        <WebUserSettingsTab />
      </section>
    </>
  )
}

UserSetting.getLayout = compose(getMainWebLayout, getWebSignedInLayout)
